import { render, staticRenderFns } from "./AddPropertyModal.vue?vue&type=template&id=66051e0f"
import script from "./AddPropertyModal.vue?vue&type=script&lang=js"
export * from "./AddPropertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports